import React from 'react'
import { Field,reduxForm } from 'redux-form'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { PHONE_REGEXP } from '../../../util/regExp'
import history from '../../../history'

const validate = ({phone,password,code}) => {
    const errors = {}
    if (!phone) {
        errors.phone = '必填'
    } else if (!PHONE_REGEXP.test(phone)) {
        errors.phone = '无效的手机号'
    }
    if (!password) {
        errors.password = '必填'
    } else if (!/^(\w){6,30}$/i.test(password)) {
        errors.password = '密码必须为6-30位的数字，字母或下划线'
    }
    if (!code) {
        errors.code = '必填'
    } else if (code.length !== 6) {
        errors.code = '验证码格式不正确'
    }
    return errors
}

const renderField = ({input,label,type,meta:{ touched,error }}) => (
    <div>
        <TextField 
            {...input}
            label={label}
            onChange={input.onChange}
            fullWidth={input.name === 'code' ? false : true}
            type={type}
            margin="normal"                         
            required  
            helperText={touched && error}
            FormHelperTextProps={{style: {color: '#F96487'}}}              
        />
    </div>
)

class SignInForm extends React.Component {
    render() {      
        const { handleSubmit,submitting,checkCode,changeCode } = this.props
        const codeStyle = { 
            fontSize: 28,
            marginRight: 20,
            textAlign: 'center',
            lineHeight: '38px',
            color: '#ea599a',
            textShadow: '5px 5px 5px #FF0000',
            border: '2px solid',
            borderRadius: 5,
            padding: '0px 8px'
        }
        return (
            <form onSubmit={handleSubmit} className="loginForm">
                <Field name="phone" component={renderField} type="text" label="手机号码"  />
                <Field name="password" component={renderField} type="password" label="密码"  />
                <div style={{ display: 'flex',justifyContent: 'space-between','alignItems': 'baseline'}}>
                    <Field name="code" component={renderField} type="text" label="验证码"  />
                    <div color="secondary" style={codeStyle} onClick={changeCode}>{checkCode}</div>
                </div>
                <div className="user-actions">
                    <Button
                        variant="raised"
                        color="primary"
                        style={{background: '#92489f'}}
                        fullWidth
                        disabled={submitting}
                        type="submit"
                    >
                        登录
                    </Button>
                </div>
                <p className="forgot" onClick={() => history.push('/sign/reset')}>忘记密码？</p>
            </form>
        )
    }
}

export default reduxForm({
    form: 'signInForm',
    validate
})(SignInForm)


// WEBPACK FOOTER //
// ./src/pages/sign/components/signInForm.js